module.exports = __webpack_public_path__ + "img/Nachos Icon - white.91b34141.svg";